<template>
  <div class="text-center qr-code">
    <div class="col-50 horizontal layout center center-justified col-qr-code">
      <div class="text-qr-code">
        {{ $t("scanQRCodeToJoin") }}
      </div>
      <i class="fas fa-arrow-right" aria-hidden="true" />
    </div>
    <div class="col-50 horizontal layout center center-justified">
      <img :src="$store.state.presentation.qrcode" alt="">
    </div>
  </div>
</template>
<script>
import Config from '@/config'
import qrCodeHelper from '@/helpers/qr-code-helper'

export default {
  mounted() {
    if (!this.$store.state.presentation.shareCode || !this.$store.state.presentation.uniqueAccessCode) {
      this.$http.get(Config.api.getPresentationBasic + this.$store.state.presentation.id).then((res) => {
        this.$store.state.presentation.shareCode = res.body.shareCode
        this.$store.state.presentation.uniqueAccessCode = res.body.uniqueAccessCode
      })
    }
    qrCodeHelper.setPresentationQRCode()
  },
}
</script>

<style lang="scss" scoped>
  .qr-code {
    width: 100%;

    img {
      max-width: 89%;
      padding-top: 4.5%;
      @media (max-width: 812px) {
        max-width: 81%;
      }
    }

  }
  .col-50 {
    width: 50%;
    float: left;
    height: 100%;
  }

  .text-qr-code {
    font-size: 58px;
    line-height: initial;
    padding: 0 10px 0 50px;
  }

  .col-qr-code {
    padding-right: 40px;
  }
  .fa-arrow-right {
    font-size: 50px;
  }
</style>
